import { render, staticRenderFns } from "./Environmental.vue?vue&type=template&id=3531943a&scoped=true"
import script from "./Environmental.vue?vue&type=script&lang=js"
export * from "./Environmental.vue?vue&type=script&lang=js"
import style0 from "./Environmental.vue?vue&type=style&index=0&id=3531943a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3531943a",
  null
  
)

export default component.exports